import NotebookPanel from "./NotebookPanel";
import LTButton from "./LTButton";

const Sidebar = ({context, notebooks, onFilterNotebooks}) => {
  const handleNewNotebook = () => {
    context.onNewNoteboookSelected();
  };
  return (
    <>
      <div
        className="offcanvas offcanvas-start"
        tabIndex={-1}
        id="offcanvas-notebook"
        aria-labelledby="offcanvasExampleLabel"
      >
        <div className="offcanvas-header">
          <div className="d-flex align-items-center gap-2">
            <h5 className="offcanvas-title mb-0" id="offcanvasExampleLabel">
              Notebooks
            </h5>
            <LTButton 
              icon="plus" 
              title="New Notebook"
              onClick={handleNewNotebook}
              data-bs-dismiss="offcanvas"
              data-bs-target="offcanvas-notebook"
            />
          </div>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <div>
           <NotebookPanel  notebooks={notebooks} onFilterNotebooks={onFilterNotebooks}></NotebookPanel>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
